import * as THREE from "three";
import {
  SAVED_CAMERA_MARKER_LINE_HEX,
  SAVED_CAMERA_MARKER_MESH_HEX,
} from "../../utils/sceneGraphNodeAppearance";

export function getSavedSceneCameraPickUuid(obj) {
  let cur = obj;
  while (cur) {
    const ud = cur.userData || {};
    if (ud.isSavedSceneCameraMarker && ud.savedSceneCameraUuid) {
      return String(ud.savedSceneCameraUuid);
    }
    cur = cur.parent;
  }
  return null;
}

export function createSavedCameraMarker(cameraDef) {
  const group = new THREE.Group();
  group.name = cameraDef?.name || cameraDef?.uuid || "saved-camera";
  group.userData = {
    type: "camera",
    cameraUuid: cameraDef?.uuid || null,
    cameraName: cameraDef?.name || null,
    savedSceneCameraUuid: cameraDef?.uuid || null,
  };

  const markerRadius = 0.045;
  const sphere = new THREE.Mesh(
    new THREE.SphereGeometry(markerRadius, 20, 16),
    new THREE.MeshBasicMaterial({
      color: SAVED_CAMERA_MARKER_MESH_HEX,
      depthTest: false,
      depthWrite: false,
      transparent: true,
      opacity: 0.92,
    })
  );
  sphere.name = "savedSceneCameraMarkerMesh";
  sphere.renderOrder = 9997;
  sphere.userData = {
    isSavedSceneCameraMarker: true,
    savedSceneCameraUuid: cameraDef?.uuid || null,
  };
  group.add(sphere);

  const pickSphere = new THREE.Mesh(
    new THREE.SphereGeometry(0.1, 12, 8),
    new THREE.MeshBasicMaterial({
      transparent: true,
      opacity: 0,
      depthTest: false,
      depthWrite: false,
    })
  );
  pickSphere.name = "savedSceneCameraMarkerPickProxy";
  pickSphere.renderOrder = 9997;
  pickSphere.userData = {
    isSavedSceneCameraMarker: true,
    savedSceneCameraUuid: cameraDef?.uuid || null,
  };
  group.add(pickSphere);

  const fovy = THREE.MathUtils.degToRad(Math.max(10, Math.min(150, Number(cameraDef?.fovy) || 65)));
  const aspect = Math.max(0.1, (Number(cameraDef?.width) || 1) / (Number(cameraDef?.height) || 1));
  const far = 0.18;
  const halfH = Math.tan(fovy / 2) * far;
  const halfW = halfH * aspect;
  const corners = [
    [-halfW, -halfH, -far],
    [halfW, -halfH, -far],
    [halfW, halfH, -far],
    [-halfW, halfH, -far],
  ];
  const pairs = [
    [0, 1],
    [1, 2],
    [2, 3],
    [3, 0],
  ];
  const positions = [];
  corners.forEach((corner) => positions.push(0, 0, 0, ...corner));
  pairs.forEach(([a, b]) => positions.push(...corners[a], ...corners[b]));

  const frustumGeometry = new THREE.BufferGeometry();
  frustumGeometry.setAttribute("position", new THREE.Float32BufferAttribute(positions, 3));
  const frustum = new THREE.LineSegments(
    frustumGeometry,
    new THREE.LineBasicMaterial({
      color: SAVED_CAMERA_MARKER_LINE_HEX,
      depthTest: false,
      depthWrite: false,
      transparent: true,
      opacity: 0.8,
    })
  );
  frustum.renderOrder = 9997;
  frustum.userData = {
    savedSceneCameraUuid: cameraDef?.uuid || null,
  };
  frustum.raycast = () => {};
  group.add(frustum);
  return group;
}
